import { cn } from '@/lib/ui/utils';

/** Inset filter chrome shared by the traders outcome picker and mobile sort select. */
export const MARKET_TAB_FILTER_TRIGGER_CLASS: string = cn(
  'flex w-full items-center justify-between gap-2',
  'rounded-control text-body-lg text-foreground-secondary',
  'h-10 px-3 border border-solid border-border-primary bg-background-secondary',
  'shadow-none transition-[color,background-color,border-color,box-shadow]',
  'hover:border-border-brand active:border-border-brand',
  'disabled:bg-background-secondary',
  'dark:bg-background-secondary dark:hover:bg-background-secondary',
);
